export default __webpack_public_path__ + "static/media/tutorial3-6.0d3f5117.png";